{
  "conversations": {
    "conversationsApp": "App Conversazioni",
    "locationId": "ID luogo",
    "idToken": "Token ID",
    "conversationRoutes": "Percorsi di conversazione",
    "conversationProviders": "Provider di conversazione",
    "viewTheListOfConversation": "Visualizza l'Elenco di conversazione fornitori di Personalizzato aggiunti Account qui.",
    "logo": "Logo",
    "name": "Nome",
    "alias": "Pseudonimo",
    "type": "Digita"
  }
}
